module.exports = __webpack_public_path__ + "img/slider-under-1.5021969a.png";